// Ajustes > General > "Sección al iniciar sesión" (profile.component.ts) y la navegación tras un
// login exitoso (ver navigateAfterLogin() en authentication.service.ts). Mismas 4 secciones
// principales del sidenav (sidenav.component.html) — si agregas una opción aquí, agrega también
// su ruta en DEFAULT_LANDING_SECTION_ROUTES, o no tendrá a dónde navegar.
export type DefaultLandingSection = 'agenda' | 'expedientes' | 'cloud' | 'finanzas';

export interface DefaultLandingSectionOption {
  value: DefaultLandingSection;
  label: string;
  // Mismos íconos que sidenav.component.html para esa sección — sólo uno de los dos aplica:
  // icon es una clase Phosphor (se combina con "ph-bold" en el template), iconImg es la ruta de
  // un ícono que no es Phosphor (Cloud usa su propio SVG, no uno del set de Phosphor).
  icon?: string;
  iconImg?: string;
}

export const DEFAULT_LANDING_SECTIONS: DefaultLandingSectionOption[] = [
  { value: 'agenda', label: 'Agenda', icon: 'ph-calendar-blank' },
  { value: 'expedientes', label: 'Expedientes', icon: 'ph-folders' },
  { value: 'cloud', label: 'Cloud', iconImg: 'assets/icons/cloud-icon.svg' },
  { value: 'finanzas', label: 'Finanzas', icon: 'ph-invoice' },
];

export const DEFAULT_LANDING_SECTION_ROUTES: Record<DefaultLandingSection, string> = {
  agenda: '/',
  expedientes: '/patients',
  cloud: '/files',
  finanzas: '/finances',
};
